import translate from '@translate';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { ReturnType } from 'src/types/return';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import RemindersItem from 'src/components/RemindersItem';

export interface TopBlockPropsType {
    data: ReturnType | null;
    idReturn: string | undefined;
    newReturn: boolean;
    disableEdit: boolean;
    permissionEditNote: boolean;
    permissionConfirm: boolean;
    loading: boolean;
    handleSave: () => Promise<boolean>;
    handleConfirm: () => void;
    activeTab: string;
    onChangeTab: (value: string) => void;
    showPdfForm: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const navigate = useNavigate();

    return (
        <>
            <BodyTopBlock
                tabs={[
                    { value: 'detail', label: translate('returnDetail.detail') },
                    { value: 'history', label: translate('returnDetail.history') },
                ]}
                selectTab={!props.newReturn ? props.activeTab : undefined}
                onChangeTab={!props.newReturn ? props.onChangeTab : undefined}
                actions={[
                    {
                        tooltip: translate('returnDetail.action.showPdfForm'),
                        onClick: props.showPdfForm,
                        hidden: props.newReturn || !props.data,
                        icon: <FindInPageIcon />,
                        variant: 'outlined',
                    },
                    {
                        label: translate('returnDetail.action.confirm'),
                        onClick: props.handleConfirm,
                        hidden:
                            !props.permissionConfirm ||
                            props.newReturn ||
                            props.activeTab !== 'detail' ||
                            props.data?.STATUS === 'confirmed',
                    },
                    {
                        actionKey: 'reminders',
                        element: !props.newReturn ? <RemindersItem type="return" idItem={props.idReturn} /> : null,
                    },
                    {
                        label: translate(props.newReturn ? 'returnDetail.action.create' : 'returnDetail.action.save'),
                        onClick: async () => {
                            await props.handleSave();
                        },
                        hidden: props.activeTab !== 'detail',
                        disabled: props.loading,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
